// The different avialability states that exist in Gladly.
// https://developer.gladly.com/glad-app/Gladly.html#.Availability
export enum GladlyAvailability {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE_OFFICE_CLOSED = 'UNAVAILABLE_OFFICE_CLOSED',
  UNAVAILABLE_BUSY = 'UNAVAILABLE_BUSY',
}
